var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Filter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8125,2c-0.47656,0.08984 -0.82031,0.51172 -0.8125,1v3c0.00391,0.25781 0.10156,0.50391 0.28125,0.6875l15.71875,16.6875v17.625c0.00781,0.34766 0.19922,0.66797 0.5,0.84375l10,6c0.30469,0.17578 0.68359,0.17969 0.99219,0.00391c0.30469,-0.17187 0.5,-0.49609 0.50781,-0.84766v-23.625l15.5625,-16.53125c0.01172,-0.01172 0.01953,-0.01953 0.03125,-0.03125l0.125,-0.125c0.04688,-0.04687 0.08984,-0.10156 0.125,-0.15625c0.02344,-0.01953 0.04297,-0.03906 0.0625,-0.0625c0.05859,-0.12891 0.08984,-0.26562 0.09375,-0.40625c0,-0.01953 0,-0.04297 0,-0.0625c0.00391,-0.05078 0.00391,-0.10547 0,-0.15625v-2.84375c0,-0.55078 -0.44922,-1 -1,-1h-42c-0.03125,0 -0.0625,0 -0.09375,0c-0.03125,0 -0.0625,0 -0.09375,0zM5,4h40v1.625l-15.4375,16.375h-9.125l-15.4375,-16.375zM21,24h8v21.25l-8,-4.78125z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Filter);
export default __webpack_public_path__ + "static/media/icons8-filter.267ab9e2f3932f906a4acdd7b8271b84.svg";
export { ForwardRef as ReactComponent };